export default {
  tipos: { method: "get", url: "api/tipos-concedentes/to-select" },
  cidades: { method: "get", url: "api/cidades/to-select" },
  upload_logo: { method: "post", url: "api/concedentes{/id}/logo" },
  remove_logo: { method: "delete", url: "api/concedentes{/id}/logo" },
  get_all: { method: "get", url: "api/concedentes" },
  show: { method: "get", url: "api/concedentes{/id}" },
  store: { method: "post", url: "api/concedentes" },
  update: { method: "put", url: "api/concedentes{/id}" },
  delete: { method: "delete", url: "api/concedentes{/id}" },
  verify_nome: { method: "get", url: "api/concedentes/verify-nome" },
};
